import React from 'react';
import {Field} from 'redux-form';
import {connect} from 'react-redux';

export default class PromotionCode extends React.Component {
    constructor( props ) {
        super( props );
    }

    render() {
        if ( !this.props.visible ) return null;
        return (
            <fieldset id="promotionCodeFields">
                <legend>Promotion Code</legend>
                <div className="gratisRequestInstructions">
                    <div className="paragraph">Please provide the promotion code
                        found on your e-mail, brochure, or catalog.
                    </div>
                </div>
                <div className="paragraph">
                    <label htmlFor="mailingId">Promotion Code</label>
                    <Field name="mailingId" type="text" maxLength="7" component="input"/>
                </div>
            </fieldset>
        );
    }
};


// WEBPACK FOOTER //
// ./src/form/components/PromotionCode.jsx